import React from 'react'
import { DisableOverridePayload } from '@/api/Wallet/Types/WithdrawalAutomationDto'
import { FormFieldLayout } from '@/components/Form/FormField'
import { Toggle } from '@/components/Toggle/Toggle'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Form, FormikProps, withFormik } from 'formik'

import { hasAtLeastOneScope, toScopePayload } from './overrideScope'
import { OverrideScopeFields, ScopeOptions } from './OverrideScopeFields'
import { disableOverrideValidationSchema } from './OverrideValidationSchema'

interface OuterProps {
  isOpen: boolean
  title: string
  initialValues: DisableOverridePayload
  options: ScopeOptions
  onClose(): void
  onSubmit(values: DisableOverridePayload): Promise<void>
}

const DisableOverrideFormUI: React.FC<OuterProps & FormikProps<DisableOverridePayload>> = (
  props
) => {
  const { values, setFieldValue, options, isOpen, onClose } = props
  const scopeSelected = hasAtLeastOneScope(values)

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <Form>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{props.title}</DialogTitle>
          </DialogHeader>

          <OverrideScopeFields values={values} setFieldValue={setFieldValue} options={options} />

          <FormFieldLayout label='Enabled'>
            <Toggle
              name='enabled'
              value={values.enabled}
              onChange={(value) => setFieldValue('enabled', value)}
            />
          </FormFieldLayout>

          {!scopeSelected && (
            <p className='text-sm text-red-500'>
              Select at least one scope (Entity, Country, PSP/Method, Client Type or Wallet Type).
            </p>
          )}

          <DialogFooter>
            <Button type='button' variant='outline' onClick={onClose}>
              Cancel
            </Button>
            <Button type='button' disabled={!props.isValid} onClick={() => props.handleSubmit()}>
              Submit
            </Button>
          </DialogFooter>
        </DialogContent>
      </Form>
    </Dialog>
  )
}

export const DisableOverrideForm = withFormik<OuterProps, DisableOverridePayload>({
  enableReinitialize: true,
  validateOnMount: true,
  validationSchema: disableOverrideValidationSchema,
  mapPropsToValues: (props) => props.initialValues,
  handleSubmit: async (values, { props, setSubmitting }) => {
    try {
      await props.onSubmit({
        ...toScopePayload(values),
        enabled: values.enabled,
      })
    } finally {
      setSubmitting(false)
    }
  },
})(DisableOverrideFormUI)
